export function phoneNumberFormatter(phoneNumberString) {
  if (!phoneNumberString || phoneNumberString === "") return "";
  // Strip from possible date special characters "(", ")" and "-"
  // Returns string in format 214-2344-5442
  return phoneNumberString
    .replace(/[-()]/g, "")
    .replace(/(\d{3})(\d{3})(\d{4})/, "$1-$2-$3");
}
